import styled from "styled-components";
import { Link } from "react-router-dom";
import { fluid } from "@/styles/utils/fluid";
import { TypoLabel1 } from "@/styles/Styled.Typography";

export const LogoLink = styled(Link)``;

export const LogoVendors = styled.svg`
  width: 48px;
  height: 48px;
`;

export const VendorTitle = styled(TypoLabel1)`
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.horizontal.xs,
      maxSize: theme.spacing.horizontal.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
`;

export const Grid = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  /* &:last-of-type {
    border-bottom: none;
  } */
  border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  margin-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1fr;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: [outer-start] 1fr 4fr [outer-end];
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: [outer-start] 1fr [center-start] 4.25fr [center-end] 0.25fr [outer-end];
  }
`;

export const GridItem = styled.div`
  &:last-child {
    padding: 0;
  }
  grid-template-rows: min-content 1fr;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
    0
  `};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    &:nth-of-type(1) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    }
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    &:nth-of-type(1) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    }
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    &:nth-of-type(1) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
      white-space: nowrap;
    }
    &:nth-of-type(2) {
      display: grid;
      grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
      padding-top: 0;
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
    gap: 0;
    padding-top: 0;
    &:nth-of-type(1) {
      min-width: 0;
      min-height: 0;
      border-bottom: none;
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.section.md,
          maxSize: theme.spacing.section.xl,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.xl,
        })}
        0
      `};
      h3 {
        overflow-wrap: break-word;
        width: min-content;
      }
    }
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    gap: 0;
    border-right: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    padding-top: 0;
    &:nth-of-type(1) {
      min-width: 0;
      min-height: 0;
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.section.md,
          maxSize: theme.spacing.section.xl,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.xl,
        })}
        0
      `};
      h3 {
        overflow-wrap: break-word;
        width: min-content;
      }
    }
  }
`;

export const GridContentWrapper = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  padding: 0;
  &:last-of-type {
    border-bottom: none;
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
    &:last-of-type {
      border-bottom: none;
    }
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
    &:last-of-type {
      border-bottom: none;
    }
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
    grid-column: center-start / center-end;

    &:last-of-type {
      border-bottom: none;
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
    gap: 0;
    &:nth-of-type(1) {
      min-width: 0;
      min-height: 0;
      border-bottom: none;
    }
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: repeat(auto-fit, minmax(480px, 1fr));
    gap: 1px;
    background: ${({ theme }) => theme.colors.phillipineSilver};
  }
`;

export const GridItemContent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.md,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.md,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.md,
    })}
    0
  `};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    &:last-of-type {
      border-bottom: none;
    }
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    &:last-of-type {
      border-bottom: none;
    }
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-column: center-start / center-end;
    border-right: none;
    &:last-of-type {
      border-bottom: none;
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.md,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      ${fluid({
        minSize: theme.spacing.vertical.md,
        maxSize: theme.spacing.vertical.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
    border-left: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    border-right: none;
    &:last-child {
      border-bottom: none;
    }
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.section.md,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
      ${fluid({
        minSize: theme.spacing.vertical.md,
        maxSize: theme.spacing.vertical.xl,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
    border-bottom: none;
    background-color: ${({ theme }) => theme.colors.white};
  }
`;
